import config from '../config';
import selectedEnvironment from '../env';

const API_BASE = config[selectedEnvironment].API_URL;
const API_URL = `${API_BASE}/Translations`;

/**
 * Translates report strings via the backend translation pipeline (cache first, then the configured engine).
 * Resolves to an object mapping each source text to its translation.
 */
const translateReportTerms = async (texts, targetLanguage, token) => {
    const response = await fetch(`${API_URL}/TranslateReportTerms`, {
        method: 'POST',
        headers: {
            "Authorization": 'Bearer ' + token,
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            Texts: texts,
            TargetLanguage: targetLanguage
        })
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Translation failed (${response.status})`);
    }

    const data = await response.json();
    return data?.translations || {};
};

const ReportTranslationService = {
    translateReportTerms,
};

export default ReportTranslationService;
